module.exports = __webpack_public_path__ + "1bd56ce7649c6dc8f1301969f45a5fb5.png";